// Mocked "previous price" value for the Pro Grow plan.
// The backend doesn't supply this information, but the UI expects a
// reference price to create the appearance of a promotion.
// If the backend starts providing this or if the promo display changes,
// we should remove or update this constant.
export const PREV_GROW_PLAN_MONTHLY_COST = 12999;
export const MONTHLY_AD_CREDITS_AMOUNT = 100;
